export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.720fb921.woff";